import { ElMessageBox } from "element-plus";
import store from "@/store";
import { globalState } from "@/state";

/** 当前是否已登录 */
export function isLogin() {
  const user = store.state.user;
  return !!(user && user.uid);
}

/** 当前登录用户 */
export function currentUser() {
  return store.state.user;
}

/**
 * 访客模式拦截：未登录时弹出「登录 / 注册」引导弹窗。
 * 已登录返回 true（可继续执行原操作）；未登录返回 false（并弹出引导）。
 *
 * @param {import('vue').ComponentPublicInstance} vm 组件实例（用于 router / route）
 * @param {string} actionText 操作名称，用于弹窗文案，如「下载文件」
 */
export function requireLogin(vm, actionText = "该功能") {
  if (isLogin()) {
    return true;
  }
  ElMessageBox.confirm(
    `「${actionText}」需要登录后才能使用。\n登录后可下载文件、使用在线互动等全部功能；注册仅需一分钟。`,
    "访客模式",
    {
      confirmButtonText: "去登录 / 注册",
      cancelButtonText: "先逛逛",
      type: "warning",
      customClass: "guest-login-dialog",
      dangerouslyUseHTMLString: false,
    }
  )
    .then(() => {
      // 记录来源页面，登录成功后可以跳回
      try {
        const path = vm && vm.$route ? vm.$route.fullPath : "";
        if (path && path !== "/login" && path !== "/register") {
          sessionStorage.setItem("login_redirect", path);
        }
      } catch (e) {
        /* ignore */
      }
      // 关闭仍打开的全局弹窗（工具详情/需求详情/小义问宝），
      // 否则路由已切换但弹窗继续遮挡，用户会误以为没有跳转
      try {
        globalState.closeModal();
        globalState.closeRequestModal();
        globalState.closeAskBot();
      } catch (e) {
        /* ignore */
      }
      if (vm && vm.$router) {
        vm.$router.push("/login");
      } else {
        window.location.href = "/login";
      }
    })
    .catch(() => {});
  return false;
}

/**
 * 页面级守卫：进入页面（如发布工具、个人中心）时校验登录态。
 * 未登录时弹窗引导并返回 false。
 */
export function requireLoginPage(vm, actionText = "该页面") {
  return requireLogin(vm, actionText);
}
